import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { getActiveExperiments as getGlobalActiveExperiments } from '@atc/optimizely-toolkit';

import experimentDuck from '@/ducks/experimentDuck';

export default function useExperiments() {
    const experiments = useSelector(experimentDuck.selectors.getExperiments);
    const isLoaded = useSelector(experimentDuck.selectors.getIsLoaded);

    const getActiveExperiments = useCallback((isUseDuckOnly) => {
        if ((isUseDuckOnly && isLoaded) || experiments.length > 0) {
            return experiments;
        }

        return getGlobalActiveExperiments();
    }, [experiments, isLoaded]);

    return {
        getActiveExperiments,
    };
}
